export default {
  historicalData: 'Datos históricos',
  simulated: 'Simulado',
  historical: 'Histórico',
  budget: 'Presupuesto',
  attributedSales: 'Atribuido al marketing',
  weekEnding: 'Semana que termina el {date}'
}
